<template>
    <div class="employee-resource-index">
        <!-- Thẻ chính bao ngoài theo phong cách bo tròn chuẩn hệ thống -->
        <v-card class="rounded-xl elevation-3" flat>
            <!-- Tiêu đề và nhóm nút hành động chính -->
            <v-card-title class="text-h6 font-weight-bold pt-4 pb-2 px-6">
                Nhận việc ứng viên
                <v-spacer></v-spacer>

                <!-- Nút tải lại dữ liệu -->
                <div class="d-flex align-center wrapper mx-1 my-1">
                    <v-btn @click="refreshData" outlined color="green lighten-3" class="rounded-lg" block
                        style="width: 40px !important; height: 40px; padding: 0px;" title="Tải lại">
                        <v-icon color="green darken-4">mdi-refresh</v-icon>
                    </v-btn>
                </div>
            </v-card-title>

            <!-- Thanh Tabs phân loại ứng viên chuẩn -->
            <div class="px-6 pb-0">
                <v-tabs v-model="tab" color="teal darken-4" class="custom-tabs" height="40">
                    <v-tab class="font-weight-bold">
                        <v-icon left small class="mr-2">mdi-account-clock-outline</v-icon>
                        Ứng viên chờ nhận việc ({{ rowCount }})
                    </v-tab>
                    <v-tab class="font-weight-bold">
                        <v-icon left small class="mr-2">mdi-account-check-outline</v-icon>
                        Đã nhận việc ({{ rowCount2 }})
                    </v-tab>
                </v-tabs>
            </div>

            <!-- Thanh bộ lọc tiêu chuẩn chuẩn hệ thống -->
            <v-sheet class="grey lighten-4 py-6" style="border-top: 1px solid #eee;">
                <div class="d-flex flex-wrap align-center px-6" style="gap: 12px;">
                    <!-- Chọn tháng -->
                    <div style="width: 140px;">
                        <month-picker v-model="currentFilters.month" label="Chọn tháng" dense outlined
                            color="teal darken-4" class="white rounded-lg"></month-picker>
                    </div>

                    <!-- Lọc theo Mã Ứng Viên -->
                    <div style="width: 140px;">
                        <v-text-field label="Mã ứng viên" placeholder="Mã UV..." dense v-model="currentFilters.code"
                            outlined hide-details color="teal darken-4" class="white rounded-lg"></v-text-field>
                    </div>

                    <!-- Lọc theo Tên Ứng Viên -->
                    <div style="width: 200px;">
                        <v-text-field label="Tên ứng viên" placeholder="Nhập tên..." dense v-model="currentFilters.name"
                            outlined hide-details color="teal darken-4" class="white rounded-lg"></v-text-field>
                    </div>

                    <!-- Lọc theo Công Việc -->
                    <div style="width: 200px;">
                        <v-autocomplete label="Công việc" dense v-model="currentFilters.jobCode" clearable
                            :items="jobs" item-value="code" item-text="name" outlined hide-details color="teal darken-4"
                            class="white rounded-lg" placeholder="Chọn công việc"></v-autocomplete>
                    </div>

                    <!-- Lọc theo SĐT -->
                    <div style="width: 140px;">
                        <v-text-field label="SĐT" placeholder="Số điện thoại..." dense v-model="currentFilters.phone"
                            outlined hide-details color="teal darken-4" class="white rounded-lg"></v-text-field>
                    </div>

                    <!-- Lọc theo Tỉnh/Thành phố -->
                    <div style="width: 180px;">
                        <v-autocomplete label="Tỉnh/Thành phố" dense v-model="currentFilters.cityCode" clearable
                            :items="cities" item-value="code" item-text="name" outlined hide-details color="teal darken-4"
                            class="white rounded-lg" placeholder="Chọn Tỉnh/TP"></v-autocomplete>
                    </div>

                    <!-- Lọc theo Ngày tạo -->
                    <div style="width: 150px;">
                        <date-picker2 v-model="currentFilters.createdAt" :range="false" label="Ngày tạo"
                            :dense="true" :hideDetails="true" outlined inputClass="white rounded-lg"></date-picker2>
                    </div>

                    <!-- Nút xóa bộ lọc -->
                    <div>
                        <v-btn @click="resetFilters" text color="grey darken-2" class="rounded-lg font-weight-bold" height="40">
                            <v-icon left small>mdi-filter-remove-outline</v-icon> Xóa lọc
                        </v-btn>
                    </div>
                </div>
            </v-sheet>

            <!-- Thanh thống kê chip màu chuẩn hệ thống -->
            <v-sheet class="px-6 py-3 d-flex align-center grey lighten-5 flex-wrap"
                style="border-top: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
                <div class="subtitle-2 font-weight-bold mr-4 text-uppercase grey--text text--darken-2">Thống kê:</div>
                <v-chip color="blue lighten-4" text-color="blue darken-4" class="mr-3 my-1 font-weight-medium" small>
                    <v-icon left small>mdi-account-group-outline</v-icon>
                    Tổng hồ sơ: <b class="ml-1">{{ rowCount + rowCount2 }}</b>
                </v-chip>
                <v-chip color="orange lighten-4" text-color="orange darken-4" class="mr-3 my-1 font-weight-medium" small>
                    <v-icon left small>mdi-account-clock-outline</v-icon>
                    Chờ nhận việc: <b class="ml-1">{{ rowCount }}</b>
                </v-chip>
                <v-chip color="green lighten-4" text-color="green darken-4" class="mr-3 my-1 font-weight-medium" small>
                    <v-icon left small>mdi-account-check-outline</v-icon>
                    Đã nhận việc: <b class="ml-1">{{ rowCount2 }}</b>
                </v-chip>
                <v-chip color="red lighten-4" text-color="red darken-4" class="my-1 font-weight-medium" small v-if="tab === 0">
                    <v-icon left small>mdi-account-cancel-outline</v-icon>
                    Từ chối nhận việc: <b class="ml-1">{{ denyCount }}</b>
                </v-chip>
            </v-sheet>

            <!-- Nội dung danh sách theo từng Tab -->
            <v-tabs-items v-model="tab">
                <!-- TAB 1: ỨNG VIÊN CHỜ NHẬN VIỆC -->
                <v-tab-item eager>
                    <v-data-table
                        class="my-custom-table"
                        :mobile-breakpoint="0" dense
                        height="calc(100vh - 380px)" fixed-header
                        :headers="headers"
                        :items="item1s"
                        :page.sync="tableParams.page"
                        :sort-by.sync="tableParams.sortBy"
                        :sort-desc.sync="tableParams.sortDesc"
                        :server-items-length="rowCount"
                        :loading="isLoading"
                        :items-per-page.sync="tableParams.pageSize"
                        loading-text="Đang tải dữ liệu..."
                        :footer-props="{
                            itemsPerPageOptions: [15, 50, 100, 200],
                            itemsPerPageText: 'Số dòng mỗi trang'
                        }"
                    >
                        <!-- Cột Thao tác -->
                        <template v-slot:[`item.actions`]="{ item }">
                            <div class="d-flex align-center flex-wrap" style="gap: 4px;">
                                <v-btn v-if="item.status === 'PASS' && !item.notAccept" x-small depressed rounded
                                    class="white--text font-weight-bold" color="teal darken-4"
                                    @click="acceptDialog = true; targetItem = item;">
                                    <v-icon left small>mdi-account-check</v-icon> Nhận việc
                                </v-btn>
                                <v-btn v-if="item.status === 'PASS' && !item.notAccept" x-small depressed rounded
                                    class="red--text text--darken-3 font-weight-bold" color="red lighten-5"
                                    @click="deny(item)">
                                    <v-icon left small>mdi-close-circle</v-icon> Từ chối
                                </v-btn>
                                <v-btn v-if="item.status === 'ACCEPT' || item.notAccept" x-small depressed rounded
                                    class="blue-grey--text text--darken-3 font-weight-bold" color="blue-grey lighten-4"
                                    @click="undo(item)">
                                    <v-icon left small>mdi-undo</v-icon> Hoàn tác
                                </v-btn>
                            </div>
                        </template>

                        <!-- Cột Ứng viên & Liên hệ -->
                        <template v-slot:[`item.name`]="{ item }">
                            <div class="d-flex align-center py-1">
                                <v-avatar size="36" class="mr-2 elevation-1 grey lighten-3 flex-shrink-0">
                                    <v-img v-if="item.avatarUrl" :src="getAvatarUrl(item.avatarUrl)">
                                        <template v-slot:placeholder>
                                            <v-icon small color="grey">mdi-account</v-icon>
                                        </template>
                                    </v-img>
                                    <v-icon v-else small color="grey">mdi-account</v-icon>
                                </v-avatar>
                                <div style="line-height: 1.3;" class="overflow-hidden">
                                    <div class="font-weight-bold text-truncate" :class="item.notAccept ? 'red--text' : 'teal--text text--darken-4'" :title="item.name">
                                        {{ item.name }}
                                    </div>
                                    <div class="caption grey--text text--darken-1 d-flex align-center">
                                        <v-icon x-small class="mr-1 grey--text">mdi-card-account-details-outline</v-icon>
                                        <span class="mr-2">{{ item.code }}</span>
                                        <span v-if="item.phone" class="d-inline-flex align-center">
                                            <v-icon x-small class="mr-1 grey--text">mdi-phone</v-icon>{{ item.phone }}
                                        </span>
                                    </div>
                                    <div class="caption grey--text text--darken-2 text-truncate" v-if="item.mail" :title="item.mail">
                                        <v-icon x-small class="mr-1 grey--text">mdi-email-outline</v-icon>{{ item.mail }}
                                    </div>
                                </div>
                            </div>
                        </template>

                        <!-- Cột Trạng thái (đặt ngay sau Ứng viên) -->
                        <template v-slot:[`item.status`]="{ item }">
                            <div class="d-flex flex-column align-center py-1" style="gap: 4px;">
                                <v-chip :color="formatStatusColor(item.status)" label small class="font-weight-bold" outlined>
                                    {{ formatStatus(item.status) }}
                                </v-chip>
                                <v-chip v-if="item.notAccept" x-small label color="red lighten-5" class="red--text text--darken-4 font-weight-bold">
                                    <v-icon left x-small>mdi-close-circle</v-icon> Từ chối
                                </v-chip>
                            </div>
                        </template>

                        <!-- Cột CCCD / Định danh -->
                        <template v-slot:[`item.idNumber`]="{ item }">
                            <div style="line-height: 1.35;" class="py-1">
                                <div class="font-weight-bold blue-grey--text text--darken-3">
                                    <v-icon x-small class="mr-1 blue-grey--text">mdi-card-bulleted-outline</v-icon>{{ item.idNumber || '--' }}
                                </div>
                                <div class="caption grey--text text--darken-1" v-if="item.idDate || item.idPlace">
                                    <div v-if="item.idDate">Cấp: {{ formatDate(item.idDate || item.iDdate || item.id_date) }}</div>
                                    <div v-if="item.idPlace" class="text-truncate" style="max-width: 170px;" :title="item.idPlace">
                                        {{ item.idPlace }}
                                    </div>
                                </div>
                            </div>
                        </template>

                        <!-- Cột Công việc ứng tuyển & Ngày nộp -->
                        <template v-slot:[`item.job`]="{ item }">
                            <div style="line-height: 1.35;" class="py-1">
                                <div class="font-weight-bold teal--text text--darken-3 text-truncate" :title="item.job">
                                    {{ item.job || '--' }}
                                </div>
                                <div class="caption grey--text text--darken-1" v-if="item.createdAt">
                                    <v-icon x-small class="mr-1 grey--text">mdi-calendar-clock</v-icon>Nộp: {{ formatDate(item.createdAt) }}
                                </div>
                            </div>
                        </template>

                        <!-- Cột Địa chỉ -->
                        <template v-slot:[`item.address`]="{ item }">
                            <div class="caption py-1" style="line-height: 1.35; max-width: 230px;">
                                <div class="font-weight-medium grey--text text--darken-3 text-truncate" :title="item.address" v-if="item.address">
                                    {{ item.address }}
                                </div>
                                <div class="grey--text text--darken-1 text-truncate" :title="getFullCityAddress(item)">
                                    <v-icon x-small class="mr-1 grey--text">mdi-map-marker-outline</v-icon>{{ getFullCityAddress(item) }}
                                </div>
                            </div>
                        </template>

                        <!-- Cột Nơi mong muốn -->
                        <template v-slot:[`item.city1`]="{ item }">
                            <div class="caption py-1" style="line-height: 1.35;">
                                <div v-if="item.city1" class="grey--text text--darken-3 text-truncate" :title="item.city1">
                                    <span class="font-weight-bold teal--text text--darken-4">NV1:</span> {{ item.city1 }}
                                </div>
                                <div v-if="item.city2" class="grey--text text--darken-2 text-truncate" :title="item.city2">
                                    <span class="font-weight-bold orange--text text--darken-3">NV2:</span> {{ item.city2 }}
                                </div>
                                <div v-if="!item.city1 && !item.city2" class="grey--text">--</div>
                            </div>
                        </template>

                        <!-- Cột Học vấn / Bằng cấp -->
                        <template v-slot:[`item.university`]="{ item }">
                            <div class="caption py-1" style="line-height: 1.35; max-width: 200px;">
                                <div class="font-weight-bold grey--text text--darken-3 text-truncate" :title="item.university" v-if="item.university">
                                    {{ item.university }}
                                </div>
                                <div class="grey--text text--darken-2 text-truncate" :title="item.educationMajor" v-if="item.educationMajor">
                                    {{ item.educationMajor }}
                                </div>
                                <div v-if="item.educationLevel" class="mt-1">
                                    <v-chip x-small label color="blue-grey lighten-5" class="blue-grey--text text--darken-3 font-weight-medium">
                                        {{ item.educationLevel }}
                                    </v-chip>
                                </div>
                                <div v-if="!item.university && !item.educationMajor && !item.educationLevel" class="grey--text">--</div>
                            </div>
                        </template>
                    </v-data-table>
                </v-tab-item>

                <!-- TAB 2: ĐÃ NHẬN VIỆC -->
                <v-tab-item eager>
                    <v-data-table
                        class="my-custom-table"
                        :mobile-breakpoint="0" dense
                        height="calc(100vh - 380px)" fixed-header
                        :headers="headers"
                        :items="item2s"
                        :page.sync="tableParam2s.page"
                        :sort-by.sync="tableParam2s.sortBy"
                        :sort-desc.sync="tableParam2s.sortDesc"
                        :server-items-length="rowCount2"
                        :loading="isLoading"
                        :items-per-page.sync="tableParam2s.pageSize"
                        loading-text="Đang tải dữ liệu..."
                        :footer-props="{
                            itemsPerPageOptions: [15, 50, 100, 200],
                            itemsPerPageText: 'Số dòng mỗi trang'
                        }"
                    >
                        <!-- Cột Thao tác -->
                        <template v-slot:[`item.actions`]="{ item }">
                            <div class="d-flex align-center">
                                <v-btn v-if="item.status === 'ACCEPT' || item.notAccept" x-small depressed rounded
                                    class="mx-1 my-1 blue-grey--text text--darken-3 font-weight-bold"
                                    color="blue-grey lighten-4" @click="undo(item)">
                                    <v-icon left small>mdi-undo</v-icon> Hoàn tác
                                </v-btn>
                            </div>
                        </template>

                        <!-- Cột Ứng viên & Liên hệ -->
                        <template v-slot:[`item.name`]="{ item }">
                            <div class="d-flex align-center py-1">
                                <v-avatar size="36" class="mr-2 elevation-1 grey lighten-3 flex-shrink-0">
                                    <v-img v-if="item.avatarUrl" :src="getAvatarUrl(item.avatarUrl)">
                                        <template v-slot:placeholder>
                                            <v-icon small color="grey">mdi-account</v-icon>
                                        </template>
                                    </v-img>
                                    <v-icon v-else small color="grey">mdi-account</v-icon>
                                </v-avatar>
                                <div style="line-height: 1.3;" class="overflow-hidden">
                                    <div class="font-weight-bold text-truncate" :class="item.notAccept ? 'red--text' : 'teal--text text--darken-4'" :title="item.name">
                                        {{ item.name }}
                                    </div>
                                    <div class="caption grey--text text--darken-1 d-flex align-center">
                                        <v-icon x-small class="mr-1 grey--text">mdi-card-account-details-outline</v-icon>
                                        <span class="mr-2">{{ item.code }}</span>
                                        <span v-if="item.phone" class="d-inline-flex align-center">
                                            <v-icon x-small class="mr-1 grey--text">mdi-phone</v-icon>{{ item.phone }}
                                        </span>
                                    </div>
                                    <div class="caption grey--text text--darken-2 text-truncate" v-if="item.mail" :title="item.mail">
                                        <v-icon x-small class="mr-1 grey--text">mdi-email-outline</v-icon>{{ item.mail }}
                                    </div>
                                </div>
                            </div>
                        </template>

                        <!-- Cột Trạng thái (đặt ngay sau Ứng viên) -->
                        <template v-slot:[`item.status`]="{ item }">
                            <div class="d-flex flex-column align-center py-1" style="gap: 4px;">
                                <v-chip :color="formatStatusColor(item.status)" label small class="font-weight-bold" outlined>
                                    {{ formatStatus(item.status) }}
                                </v-chip>
                                <v-chip v-if="item.notAccept" x-small label color="red lighten-5" class="red--text text--darken-4 font-weight-bold">
                                    <v-icon left x-small>mdi-close-circle</v-icon> Từ chối
                                </v-chip>
                            </div>
                        </template>

                        <!-- Cột CCCD / Định danh -->
                        <template v-slot:[`item.idNumber`]="{ item }">
                            <div style="line-height: 1.35;" class="py-1">
                                <div class="font-weight-bold blue-grey--text text--darken-3">
                                    <v-icon x-small class="mr-1 blue-grey--text">mdi-card-bulleted-outline</v-icon>{{ item.idNumber || '--' }}
                                </div>
                                <div class="caption grey--text text--darken-1" v-if="item.idDate || item.idPlace">
                                    <div v-if="item.idDate">Cấp: {{ formatDate(item.idDate || item.iDdate || item.id_date) }}</div>
                                    <div v-if="item.idPlace" class="text-truncate" style="max-width: 170px;" :title="item.idPlace">
                                        {{ item.idPlace }}
                                    </div>
                                </div>
                            </div>
                        </template>

                        <!-- Cột Công việc ứng tuyển & Ngày nộp -->
                        <template v-slot:[`item.job`]="{ item }">
                            <div style="line-height: 1.35;" class="py-1">
                                <div class="font-weight-bold teal--text text--darken-3 text-truncate" :title="item.job">
                                    {{ item.job || '--' }}
                                </div>
                                <div class="caption grey--text text--darken-1" v-if="item.createdAt">
                                    <v-icon x-small class="mr-1 grey--text">mdi-calendar-clock</v-icon>Nộp: {{ formatDate(item.createdAt) }}
                                </div>
                            </div>
                        </template>

                        <!-- Cột Địa chỉ -->
                        <template v-slot:[`item.address`]="{ item }">
                            <div class="caption py-1" style="line-height: 1.35; max-width: 230px;">
                                <div class="font-weight-medium grey--text text--darken-3 text-truncate" :title="item.address" v-if="item.address">
                                    {{ item.address }}
                                </div>
                                <div class="grey--text text--darken-1 text-truncate" :title="getFullCityAddress(item)">
                                    <v-icon x-small class="mr-1 grey--text">mdi-map-marker-outline</v-icon>{{ getFullCityAddress(item) }}
                                </div>
                            </div>
                        </template>

                        <!-- Cột Nơi mong muốn -->
                        <template v-slot:[`item.city1`]="{ item }">
                            <div class="caption py-1" style="line-height: 1.35;">
                                <div v-if="item.city1" class="grey--text text--darken-3 text-truncate" :title="item.city1">
                                    <span class="font-weight-bold teal--text text--darken-4">NV1:</span> {{ item.city1 }}
                                </div>
                                <div v-if="item.city2" class="grey--text text--darken-2 text-truncate" :title="item.city2">
                                    <span class="font-weight-bold orange--text text--darken-3">NV2:</span> {{ item.city2 }}
                                </div>
                                <div v-if="!item.city1 && !item.city2" class="grey--text">--</div>
                            </div>
                        </template>

                        <!-- Cột Học vấn / Bằng cấp -->
                        <template v-slot:[`item.university`]="{ item }">
                            <div class="caption py-1" style="line-height: 1.35; max-width: 200px;">
                                <div class="font-weight-bold grey--text text--darken-3 text-truncate" :title="item.university" v-if="item.university">
                                    {{ item.university }}
                                </div>
                                <div class="grey--text text--darken-2 text-truncate" :title="item.educationMajor" v-if="item.educationMajor">
                                    {{ item.educationMajor }}
                                </div>
                                <div v-if="item.educationLevel" class="mt-1">
                                    <v-chip x-small label color="blue-grey lighten-5" class="blue-grey--text text--darken-3 font-weight-medium">
                                        {{ item.educationLevel }}
                                    </v-chip>
                                </div>
                                <div v-if="!item.university && !item.educationMajor && !item.educationLevel" class="grey--text">--</div>
                            </div>
                        </template>
                    </v-data-table>
                </v-tab-item>
            </v-tabs-items>
        </v-card>

        <!-- Hộp thoại xác nhận xóa ứng viên -->
        <v-dialog v-model="dialogDelete" max-width="450px" persistent>
            <v-card class="rounded-xl">
                <v-card-title class="text-subtitle-1 font-weight-bold px-6 py-4 d-flex align-center">
                    <v-icon left color="error">mdi-alert-circle-outline</v-icon>
                    Xác nhận xóa dữ liệu ứng viên
                    <v-spacer></v-spacer>
                    <v-btn icon small @click="dialogDelete = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="px-6 py-4 pt-4">
                    Bạn có chắc muốn xoá dữ liệu này? Thao tác này không thể hoàn tác.
                </v-card-text>
                <v-card-actions class="px-6 pb-4">
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text class="rounded-lg font-weight-bold px-4" @click="dialogDelete = false">Hủy</v-btn>
                    <v-btn color="red darken-1" dark class="rounded-lg font-weight-bold px-4" depressed @click="cfmDeleteItem">Xóa</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Hộp thoại quyết định nhận việc nhân viên -->
        <v-dialog v-model="acceptDialog" max-width="850px" scrollable persistent>
            <v-card class="rounded-xl">
                <v-card-title class="teal darken-4 white--text text-h6 font-weight-bold px-6 py-4">
                    <v-icon left color="white">mdi-account-check</v-icon>
                    Quyết định nhận việc nhân viên
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="close"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>

                <v-card-text class="px-6 py-6 white" style="max-height: calc(100vh - 160px);">
                    <!-- Nhóm 1: Thông tin ứng viên -->
                    <div class="d-flex align-center mb-5 mt-2">
                        <div class="subtitle-1 font-weight-bold teal--text text--darken-4 text-uppercase pr-4">
                            <v-icon left color="teal darken-4">mdi-account-circle-outline</v-icon> Thông tin ứng viên
                        </div>
                        <v-divider></v-divider>
                    </div>

                    <v-row v-if="targetItem" class="mb-2 align-center">
                        <v-col cols="12" md="3" class="text-center py-1">
                            <v-avatar size="100" class="elevation-2 grey lighten-3">
                                <v-img v-if="targetItem.avatarUrl" :src="getAvatarUrl(targetItem.avatarUrl)">
                                    <template v-slot:placeholder>
                                        <v-icon large color="grey">mdi-account</v-icon>
                                    </template>
                                </v-img>
                                <v-icon v-else large color="grey">mdi-account</v-icon>
                            </v-avatar>
                        </v-col>
                        <v-col cols="12" md="9" class="py-1">
                            <v-row dense>
                                <v-col cols="12" sm="6">
                                    <v-text-field :value="targetItem.code" label="Mã ứng viên" readonly outlined dense hide-details></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field :value="targetItem.name" label="Tên ứng viên" readonly outlined dense hide-details></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field :value="targetItem.phone" label="Số điện thoại" readonly outlined dense hide-details></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field :value="targetItem.idNumber" label="Số CCCD" readonly outlined dense hide-details></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field :value="formatDate(targetItem.idDate || targetItem.iDdate || targetItem.id_date)" label="Ngày cấp CCCD" readonly outlined dense hide-details></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field :value="targetItem.idPlace" label="Nơi cấp" readonly outlined dense hide-details></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field :value="targetItem.job" label="Công việc ứng tuyển" readonly outlined dense hide-details></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <!-- Nhóm 2: Thông tin nhận việc -->
                    <div class="d-flex align-center mb-5 mt-4">
                        <div class="subtitle-1 font-weight-bold teal--text text--darken-4 text-uppercase pr-4">
                            <v-icon left color="teal darken-4">mdi-briefcase-check-outline</v-icon> Thông tin nhận việc
                        </div>
                        <v-divider></v-divider>
                    </div>

                    <v-row dense>
                        <v-col cols="12" md="6" class="py-1">
                            <date-picker2 :range="false" v-model="form.hireDate" label="Ngày nhận việc" :outlined="true" :hide-details="true" :dense="true"></date-picker2>
                        </v-col>
                        <v-col cols="12" md="6" class="py-1">
                            <v-text-field v-model="form.code" label="Mã nhân viên (tự sinh nếu để trống)" outlined dense hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="py-1" v-show="!form.isDepot">
                            <v-autocomplete v-model="form.temporaryStoreId" label="Chuẩn bị mở mới" item-text="name" item-value="id" :items="temporaryStores" outlined dense hide-details clearable></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="6" class="py-1" v-show="!form.isDepot">
                            <v-autocomplete v-model="form.departmentTypeCode" label="Khối" item-text="name" item-value="code" :items="departmentTypes" outlined dense hide-details clearable></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="6" class="py-1" v-show="!form.isDepot">
                            <v-autocomplete v-model="form.departmentCode" label="Phòng ban" item-text="name" item-value="code" :items="departments" outlined dense hide-details clearable></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="6" class="py-1">
                            <v-autocomplete v-model="form.positionCode" label="Vị trí" item-text="name" item-value="code" :items="positions" outlined dense hide-details clearable></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="6" class="py-1">
                            <v-autocomplete v-model="form.positionStateCode" label="Chức danh" item-text="name" item-value="code" :items="positionStates" outlined dense hide-details clearable></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="6" class="py-1">
                            <v-autocomplete v-model="form.shiftCode" label="Ca làm việc" item-text="name" item-value="code" :items="shifts" outlined dense hide-details clearable
                                hint="Lưu ý: Nhân viên hỗ trợ sử dụng CA VĂN PHÒNG, chi nhánh sử dụng ca tương ứng với chức danh" persistent-hint></v-autocomplete>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>
                <v-card-actions class="px-6 py-3 grey lighten-4">
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text class="px-4 font-weight-bold rounded-lg" @click="close">
                        Thoát
                    </v-btn>
                    <v-btn color="teal darken-4" dark class="px-6 font-weight-bold rounded-lg elevation-2" @click="recruit(targetItem)">
                        <v-icon left small>mdi-check</v-icon> Duyệt nhận việc
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
// Nhập các component và dịch vụ xử lý dữ liệu
import http from '@/components/services/http-common';
import * as moment from "moment/moment";
import DatePicker2 from '../../../components/DatePicker2.vue';

export default {
    name: "EmployeeResourceIndex",
    components: {
        DatePicker2
    },
    props: ["breadcrumbs", "icon"],
    data() {
        return {
            ROOT_URL: "EmployeeResource",
            POSITION_FETCH: "departments/fetch-position/",
            POSITION_STATE_FETCH: "positions/fetch-position-state",
            endpoint: process.env.VUE_APP_BASE_URL,

            // Tab hiện tại (0: Ứng viên chờ nhận việc, 1: Đã nhận việc)
            tab: 0,

            // Tham số phân trang cho tab 1
            tableParams: {
                sortBy: [],
                sortDesc: [],
                page: 1,
                pageSize: 15
            },

            // Tham số phân trang cho tab 2
            tableParam2s: {
                sortBy: [],
                sortDesc: [],
                page: 1,
                pageSize: 15
            },

            // Danh sách dữ liệu danh mục
            jobs: [],
            cities: [],
            unis: [],
            eduLvls: [],
            majors: [],
            temporaryStores: [],
            departments: [],
            departmentTypes: [],
            positions: [],
            positionStates: [],
            shifts: [],

            // Bộ lọc tab 1
            filters: {
                code: null,
                createdAt: null,
                status: 'PASS',
                name: null,
                jobCode: null,
                cityCode: null,
                city1Code: null,
                city2Code: null,
                unisCode: null,
                eduLevelCode: null,
                majorCode: null,
                phone: null,
                mail: null,
                month: moment().format("YYYY-MM")
            },

            // Bộ lọc tab 2
            filter2s: {
                code: null,
                createdAt: null,
                status: 'ACCEPT',
                name: null,
                jobCode: null,
                cityCode: null,
                city1Code: null,
                city2Code: null,
                unisCode: null,
                eduLevelCode: null,
                majorCode: null,
                phone: null,
                mail: null,
                month: moment().format("YYYY-MM")
            },

            // Số lượng dòng dữ liệu
            rowCount: 0,
            rowCount2: 0,

            // Danh sách dữ liệu hiển thị
            item1s: [],
            item2s: [],
            isLoading: true,

            // Dialogs
            acceptDialog: false,
            dialogDelete: false,
            targetItem: undefined,

            // Form nhận việc
            form: {
                code: "",
                isDepot: false,
                departmentCode: "",
                departmentTypeCode: "",
                hireDate: moment().format("YYYY-MM-DD"),
                positionCode: undefined,
                positionStateCode: undefined,
                shiftCode: undefined,
                temporaryStoreId: null
            },

            defaultForm: {
                code: "",
                isDepot: false,
                departmentCode: "",
                departmentTypeCode: "",
                hireDate: moment().format("YYYY-MM-DD"),
                positionCode: undefined,
                positionStateCode: undefined,
                shiftCode: undefined,
                temporaryStoreId: null
            },

            // Cấu hình cột hiển thị (gộp nhóm thông tin tối ưu, chống tràn ngang)
            headers: [
                { text: 'Thao tác', value: 'actions', width: 140, align: 'center', sortable: false },
                { text: 'Ứng viên & Liên hệ', align: 'start', value: 'name', width: 230 },
                { text: 'Trạng thái', align: 'center', value: 'status', width: 130 },
                { text: 'CCCD / Định danh', align: 'start', value: 'idNumber', width: 180 },
                { text: 'Công việc & Ngày nộp', align: 'start', value: 'job', width: 200 },
                { text: 'Địa chỉ', align: 'start', value: 'address', width: 230 },
                { text: 'Nơi mong muốn', align: 'start', value: 'city1', width: 160, sortable: false },
                { text: 'Học vấn / Bằng cấp', align: 'start', value: 'university', width: 200 }
            ]
        };
    },
    computed: {
        // Trả về bộ lọc tương ứng với tab đang chọn
        currentFilters() {
            return this.tab === 0 ? this.filters : this.filter2s;
        },

        // Đếm số lượng ứng viên từ chối nhận việc ở tab hiện tại
        denyCount() {
            return (this.item1s || []).filter(x => x.notAccept).length;
        },

        // Tham số gửi API cho tab 1
        params() {
            return { ...this.tableParams, ...this.filters };
        },

        // Tham số gửi API cho tab 2
        param2s() {
            return { ...this.tableParam2s, ...this.filter2s };
        }
    },
    watch: {
        acceptDialog(val) {
            this.fetchCity();
            if (!val) {
                this.targetItem = null;
                this.form = Object.assign({}, this.defaultForm);
            }
        },
        tableParams: {
            handler() {
                this.fetchData();
            },
            deep: true
        },
        tableParam2s: {
            handler() {
                this.fetchData2();
            },
            deep: true
        },
        filters: {
            handler() {
                this.tableParams.page = 1;
                this.fetchData();
            },
            deep: true
        },
        filter2s: {
            handler() {
                this.tableParam2s.page = 1;
                this.fetchData2();
            },
            deep: true
        },
        "form.departmentTypeCode": {
            handler(val) {
                this.fetchDepartments(val);
            }
        },
        "form.departmentCode": {
            handler(val) {
                this.fetchPosition(val);
            }
        },
        "form.positionCode": {
            handler(val) {
                this.fetchPositionState(val);
            }
        },
        "form.positionStateCode": {
            handler(val) {
                if (val === "PST00013") {
                    this.form.shiftCode = "CLV00023";
                }
            }
        }
    },
    methods: {
        // Định dạng URL ảnh đại diện
        getAvatarUrl(url) {
            if (!url) return '';
            if (url.startsWith('http')) return url;
            return this.endpoint + url.replace('wwwroot/', '');
        },

        // Tải lại dữ liệu cả 2 tab
        refreshData() {
            this.fetchData();
            this.fetchData2();
        },

        // Đặt lại các giá trị lọc
        resetFilters() {
            const defaultMonth = moment().format("YYYY-MM");
            if (this.tab === 0) {
                this.filters = {
                    code: null,
                    createdAt: null,
                    status: 'PASS',
                    name: null,
                    jobCode: null,
                    cityCode: null,
                    city1Code: null,
                    city2Code: null,
                    unisCode: null,
                    eduLevelCode: null,
                    majorCode: null,
                    phone: null,
                    mail: null,
                    month: defaultMonth
                };
            } else {
                this.filter2s = {
                    code: null,
                    createdAt: null,
                    status: 'ACCEPT',
                    name: null,
                    jobCode: null,
                    cityCode: null,
                    city1Code: null,
                    city2Code: null,
                    unisCode: null,
                    eduLevelCode: null,
                    majorCode: null,
                    phone: null,
                    mail: null,
                    month: defaultMonth
                };
            }
        },

        // Định dạng trạng thái text
        formatStatus(value) {
            switch (value) {
                case "NEW":
                    return "Mới";
                case "PEND":
                    return "Chờ";
                case "PASS":
                    return "Đạt";
                case "FAIL":
                    return "Loại";
                case "ACCEPT":
                    return "Đã nhận việc";
                case "DENY":
                    return "Từ chối";
                default:
                    return value;
            }
        },

        // Định dạng màu sắc trạng thái
        formatStatusColor(value) {
            switch (value) {
                case "NEW":
                    return "blue-grey";
                case "PEND":
                    return "orange";
                case "PASS":
                    return "success";
                case "FAIL":
                    return "error";
                case "ACCEPT":
                    return "teal darken-4";
                case "DENY":
                    return "purple";
                default:
                    return "grey";
            }
        },

        // Đóng dialog duyệt nhận việc
        close() {
            this.acceptDialog = false;
            this.targetItem = undefined;
            this.form = Object.assign({}, this.defaultForm);
        },

        // Duyệt nhận việc ứng viên
        recruit(item) {
            return http.post("employeeResource/recruit/" + item.code, this.form).then(() => {
                item.status = "ACCEPT";
                this.refreshData();
                this.close();
            });
        },

        // Hoàn tác trạng thái nhận việc
        undo(item) {
            return http.get("employeeResource/undo/" + item.code).then(() => {
                this.refreshData();
            });
        },

        // Từ chối ứng viên nhận việc
        deny(item) {
            return http.get("employeeResource/deny/" + item.code).then(() => {
                this.refreshData();
            });
        },

        // Định dạng ngày hiển thị (xử lý linh hoạt cả chuỗi DD/MM/YYYY, YYYY-MM-DD, ISO string, timestamp)
        formatDate(value) {
            if (!value || value === "0001-01-01T00:00:00" || value === "01/01/0001" || value === "1900-01-01" || value === "null") return "--";

            if (typeof value === "string") {
                const str = value.trim();
                if (!str || str === "--") return "--";

                // Nếu chuỗi đã ở dạng chuẩn DD/MM/YYYY
                if (/^\d{2}\/\d{2}\/\d{4}$/.test(str)) {
                    return str;
                }

                // Nếu ở dạng D/M/YYYY
                if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(str)) {
                    const parts = str.split('/');
                    return `${parts[0].padStart(2, '0')}/${parts[1].padStart(2, '0')}/${parts[2]}`;
                }

                // Nếu ở dạng DD-MM-YYYY hoặc D-M-YYYY
                if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(str)) {
                    const parts = str.split('-');
                    return `${parts[0].padStart(2, '0')}/${parts[1].padStart(2, '0')}/${parts[2]}`;
                }

                // Parse theo thứ tự ưu tiên các định dạng
                const parsed = moment(str, [
                    "DD/MM/YYYY",
                    "D/M/YYYY",
                    "DD-MM-YYYY",
                    "D-M-YYYY",
                    "YYYY-MM-DD",
                    "YYYY-MM-DDTHH:mm:ss",
                    "YYYY-MM-DDTHH:mm:ss.SSSZ",
                    "YYYY/MM/DD",
                    moment.ISO_8601
                ], true);

                if (parsed.isValid()) {
                    return parsed.format("DD/MM/YYYY");
                }

                // Fallback non-strict
                const fallback = moment(str);
                if (fallback.isValid() && fallback.year() > 1900) {
                    return fallback.format("DD/MM/YYYY");
                }

                return str;
            }

            const m = moment(value);
            return m.isValid() && m.year() > 1900 ? m.format("DD/MM/YYYY") : value;
        },

        // Ghép địa chỉ khu vực Phường, Quận, Tỉnh thành
        getFullCityAddress(item) {
            if (!item) return '--';
            const parts = [item.ward, item.district, item.city].filter(Boolean);
            return parts.length > 0 ? parts.join(', ') : (item.address ? '' : '--');
        },

        // Lấy danh mục công việc
        fetchJob() {
            return http.get("jobs").then(res => {
                this.jobs = res.data;
            });
        },

        // Lấy danh mục tỉnh thành
        fetchCity() {
            return http.get("cities/fetch").then(res => {
                this.cities = res.data.data;
            });
        },

        // Lấy danh mục phòng ban theo khối
        fetchDepartments(deptType) {
            if (deptType) {
                return http.get("departmentTypes/fetch-department/" + deptType).then(res => {
                    this.departments = res.data;
                });
            }
        },

        // Lấy danh mục cửa hàng tạm
        fetchTemporaryStores() {
            return http.get("temporaryStores").then(res => {
                this.temporaryStores = res.data.data;
            });
        },

        // Lấy danh mục khối
        fetchDepartmentTypes() {
            return http.get("departmentTypes/fetch").then(res => {
                this.departmentTypes = res.data;
            });
        },

        // Lấy danh mục ca làm việc
        fetchShift() {
            return http.get("shifts").then(res => {
                this.shifts = res.data;
            });
        },

        // Lấy vị trí theo phòng ban
        fetchPosition(val) {
            if (val) {
                return http.get(this.POSITION_FETCH + val).then(res => {
                    this.positions = res.data;
                    if (this.positions.map(x => x.code).includes("CV00061")) {
                        this.form.positionCode = "CV00061";
                    }
                    if (this.positions.map(x => x.code).includes("CV00067")) {
                        this.form.positionCode = "CV00067";
                    }
                });
            }
        },

        // Lấy chức danh theo vị trí
        fetchPositionState(val) {
            if (val) {
                const url = `${this.POSITION_STATE_FETCH}/${val}`;
                return http.get(url).then(res => {
                    this.positionStates = res.data;
                });
            }
        },

        // Lấy dữ liệu tab 1 (Chờ nhận việc)
        fetchData() {
            this.isLoading = true;
            return http.get(this.ROOT_URL, {
                params: this.params
            }).then(res => {
                this.item1s = res.data.results || [];
                this.rowCount = res.data.rowCount || 0;
            }).catch(err => {
                console.error("Lỗi tải ứng viên:", err);
            }).finally(() => {
                this.isLoading = false;
            });
        },

        // Lấy dữ liệu tab 2 (Đã nhận việc)
        fetchData2() {
            this.isLoading = true;
            return http.get(this.ROOT_URL, {
                params: this.param2s
            }).then(res => {
                this.item2s = res.data.results || [];
                this.rowCount2 = res.data.rowCount || 0;
            }).catch(err => {
                console.error("Lỗi tải đã nhận việc:", err);
            }).finally(() => {
                this.isLoading = false;
            });
        },

        // Lấy danh mục trường học
        fetchUni() {
            return http.get("Universities?dropDown=1").then(res => {
                this.unis = res.data;
            });
        },

        // Lấy danh mục chuyên ngành
        fetchMajor() {
            return http.get("educationMajors?dropDown=1").then(res => {
                this.majors = res.data;
            });
        },

        // Lấy danh mục trình độ
        fetcheducationLevels() {
            return http.get("educationLevels?dropDown=1").then(res => {
                this.eduLvls = res.data;
            });
        },

        // Xóa ứng viên
        remove(item) {
            this.dialogDelete = true;
            this.targetItem = item;
        },

        // Xác nhận xóa
        cfmDeleteItem() {
            if (!this.targetItem) return;
            return http.delete("candidates/" + this.targetItem.code).then(() => {
                this.refreshData();
                this.dialogDelete = false;
                this.targetItem = undefined;
            });
        }
    },
    created() {
        this.fetchJob();
        this.fetchCity();
        this.fetchUni();
        this.fetchMajor();
        this.fetcheducationLevels();
        this.fetchData();
        this.fetchData2();
        this.fetchShift();
        this.fetchTemporaryStores();
        this.$emit("setUrl", this.breadcrumbs);
        this.fetchDepartmentTypes();
    },
    destroyed() {
        this.$emit("setUrl", []);
    }
};
</script>

<style scoped>
/* Định dạng tiêu đề cột bảng dữ liệu */
.my-custom-table ::v-deep thead th {
    background-color: #F8F9FA !important; 
    height: 48px !important;
}

.my-custom-table ::v-deep thead th span {
    font-weight: 600 !important;
    color: #37474F !important;
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 0.05em;
}

/* Định dạng thanh Tabs */
.custom-tabs ::v-deep .v-tab {
    text-transform: none !important;
    letter-spacing: normal !important;
}

/* Hiệu ứng hover dòng trong bảng */
.my-custom-table ::v-deep tbody tr:hover {
    background-color: #F1F8E9 !important;
}

/* Khoảng cách ô bảng dữ liệu */
.my-custom-table ::v-deep tbody td {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
}
</style>